// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tcEvl7OsyvUpVb5I6__V{width:340px}.prAsjYtIbY5PGiNl7X5n{border-bottom:1px solid var(--background-neutral-default);align-items:center;height:40px;padding-left:12px;display:flex}.JHJ9UE3Bao4r_QKQqNLr{padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `tcEvl7OsyvUpVb5I6__V`,
	"header": `prAsjYtIbY5PGiNl7X5n`,
	"content": `JHJ9UE3Bao4r_QKQqNLr`
};
export default ___CSS_LOADER_EXPORT___;
